export const convertPdomainsToPidsDropdownMenu = (pids) =>
  pids.map((p) => {
    const name = `ID - ${p.display_name}`;
    return { ...p, label: name, value: p.id };
  });
